// extracted by css-extract-rspack-plugin
export default {"group":"group-fwAMGx","auto":"auto-uYsUwk","two":"two-dEjeJt","one":"one-VK2AYf","tile":"tile-OE9PMD","segments":"segments-g_S9j9","segment":"segment-viSvdr"};